export const PATTERNS = {
  ALPHANUMERIC_WITH_SPACES: '^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\\s]*$',
};
